import { DateTime } from 'luxon';
import type { ParkingRecordBill } from '@autopass-web/types';

// sort by 相符程度 > 名稱 (0-9, A-Z) > 進場時間近到舊
export function sortByPlateNumberAndCheckedInTime(
  a: ParkingRecordBill,
  b: ParkingRecordBill,
) {
  const aPlate = a.plate_number.replace('-', '');
  const bPlate = b.plate_number.replace('-', '');
  if (aPlate < bPlate) return -1;
  if (aPlate > bPlate) return 1;

  if (DateTime.fromISO(a.checked_in_at) >= DateTime.fromISO(b.checked_in_at))
    return -1;
  if (DateTime.fromISO(a.checked_in_at) < DateTime.fromISO(b.checked_in_at))
    return 1;

  return 0;
}
